import React from "react";
import styled from "styled-components";

export default styled.div`
    position: absolute;
    bottom: 52px;
    left: 52px;
`;